import React from 'react';
import { Text, View, TouchableOpacity, Dimensions, InteractionManager } from 'react-native';
//import { LineChart } from "react-native-chart-kit";
import { ChartOrd, Data, OrdData, PosData } from '../~Utilities/Data';
import QB from '../~Screens/QB';
import Utilities from '../~Utilities/Utilities';
import { AppMain, FontInfo, IIndicatorInfo, IndicatorType, IPeriodInfo } from '../~Utilities/Constants';
import { processFontFamily,} from 'expo-font';
import { Connection, ConnectionHis, ConnectionMkt, ConnectionOrd, IChartSettings, IIndicator as IIndicatorSettings, ISettings } from '../~Utilities/Connection';
import { TransactionType } from '../~Utilities/Rq';
// import { LineChart } from "react-native-chart-kit";

import victory from '../C_Text/victory';

import { Ionicons } from '@expo/vector-icons';
import ChartConfig, { IChartConfigStateToChart } from '../C_Popups/ChartConfig';

//import { AntDesign, EvilIcons, Feather, Ionicons } from '@expo/vector-icons';
// import { VictoryBar, VictoryLine, VictoryArea, VictoryChart, VictoryAxis, VictoryTheme, VictoryContainer } from '../C_Text/victory' ///"victory";
//import { LineChart } from 'echarts/charts';
//import { GridComponent } from 'echarts/components'
//import { SVGRenderer, SvgChart, } from '@wuba/react-native-echarts';
//import echarts from 'echarts';
//import * as echarts from 'echarts/core';
//import ECharts as excharts from 'echarts';

//echarts.use([SVGRenderer, LineChart, GridComponent]);

import { add, multiplyBy, subtract, mstd, sma, ema, mmax, mmin, divideBy, keltnerChannel, atr, trima, 
        dema, tema, trix, rma, typicalPrice, checkSameLength, multiply, addBy, msum,
        abs, extractSigns, pow, shiftRightAndFillBy, shiftRightBy,
        generateNumbers, movingLeastSquare,
        } from 'indicatorts';
//import { relativeTimeThreshold } from 'moment';


// import { Chivo_200ExtraLight } from '@expo-google-fonts/chivo';

const CHART_LEFT  = 60;//65;//55;
const CHART_RIGHT = 55;//50;//60;

/*   ====================================================================   */

export interface IChartEx
{
  oData           : Data;
  iSettIndex      : number;
  qbRef           : QB;
  bindEvent       : (onEvent    : (() => void), 
                     bSubscribe : boolean) => void
}

/*   ====================================================================   */

interface IChartState
{
  points?         : any[];
}

/*   ====================================================================   */

interface ILine
{
  oData?      : any[];
  sColor?     : string;
  iPeriod     : number;
}

/*   ====================================================================   */

interface IIndicator
{
   iIndicator : number;
   iIndex     : number;
   oL1        : ILine;
   oL2        : ILine;
   oL3        : ILine;

   bOverlay?  : boolean;
}

/*   ====================================================================   */

// const E_HEIGHT = 100;
// const E_WIDTH  = 350;

export default class ChartEx extends React.Component<IChartEx>
 {

    private oPosData    : PosData | undefined = undefined;
    private oOrders     = new Map<number, ChartOrd>(); 
    private oCloses?    : number[];
    private oFutData?   : ChartOrd;
    private oPoints     : number[] = new Array(0); // = [0];

    private oIndicators : IIndicator[] = new Array(0);
    
    // private oL1         : ILine = {iPeriod: 0};
    // private oL2         : ILine = {iPeriod: 0};
    // private oL3         : ILine = {iPeriod: 0};

    private dMin        : number   = 0;
    private dMax        : number   = 0;
    private dMean       : number   = 0;

    private dMin2       : number   = 0;
    private dMax2       : number   = 0;
    private dMean2      : number   = 0;

    private dDecimals   : number   = 2;
    private bChart      : boolean  = false;
    private iChartType  : number   = ChartConfig.TYPE_LINE;
    private iColIndex   : number   = 0;
    private iLineWidth  : number   = 2;

    //private iMaxRec     : number   = 100;
    // private iIndicator? : number;

    // private iPdIndex    : number   = 0;
    state : IChartState = {points : []};
    // private skiaRef;
    // private chart;

    /*   -----------------------------------------------------------------   */

    private iIndexOvr? : number;
    private iIndexUdr? : number;

    /*   -----------------------------------------------------------------   */

    setSingleIndicator(oL       : ILine,
                       oFn      : (iPd:number, oData:number[]) => number[],
                       bOverlay : boolean | undefined,
                       bForce   : boolean = false)
    {
      if (!oL.iPeriod)
        return;

      /*   ---------------------------------------------------------------   */

      if (bForce || this.props.oData.update_chart_rr || !oL.oData ||
          (!bOverlay && oL.oData.length < oL.iPeriod - 1))
        {
        let oData   = oFn(oL.iPeriod, this.oPoints);

        if (oL.oData == undefined)
          oL.oData = new Array(this.oPoints.length);
        else
          oL.oData.splice(0, oL.oData.length);

        /*   -------------------------------------------------------------   */

        if (bOverlay)
          {
          for (let i = oL.iPeriod - 1; i < this.oPoints.length; i++)
            {
            oL.oData[i] = oData[i];

            if (oL.oData[i] != undefined)
              {
              if (this.dMin > oL.oData[i])
                this.dMin = oL.oData[i];
              else if (this.dMax < oL.oData[i])
                this.dMax = oL.oData[i];
              }
            }

          this.dMean = (this.dMin + this.dMax)/2;
          }
        else
          {
          let bMin = false;

          for (let i = 0; i < this.oPoints.length; i++)
            {
            oL.oData[i] = Number.isNaN(oData[i])? 0 : oData[i];

            if (oL.oData[i] != undefined)
              {
              if (bMin == false)
                {
                this.dMin2 = oL.oData[i];
                this.dMax2 = oL.oData[i];
                bMin       = true;
                }  
              else if (this.dMin2 > oL.oData[i])
                {
                this.dMin2 = oL.oData[i];
                }
              else if (this.dMax2 < oL.oData[i])
                {
                this.dMax2 = oL.oData[i];
                }
              }
            }

          this.dMean2 = (this.dMin2 + this.dMax2)/2;
          }
        }
      else if (this.props.oData.update_chart) //new data added
        {
        // if (oL.oData.length < oL.iPeriod - 1) //not enough points
        //   {
        //   oL.oData = new Array(this.oPoints.length);
        //   }
        // else //calculate and add only the new point
        if (!this.updateOneEmptyValues(oL))
          {
          let oData : number[];

          if (this.oPoints.length >= oL.iPeriod)
            oData = oFn(oL.iPeriod, this.oPoints.slice(this.oPoints.length - oL.iPeriod));
          else
            oData = oFn(oL.iPeriod, this.oPoints);

          /*   -----------------------------------------------------------   */

          oL.oData.push(Number.isNaN(oData[oData.length - 1])? 0 : oData[oData.length - 1]);  
          }

        /*   -------------------------------------------------------------   */

        //remove the first point to adjust overflow
        if (oL.oData.length > this.props.oData.lookback.Max) 
          oL.oData.splice(0, 1);

        /*   -------------------------------------------------------------   */

        this.findMinMaxFromOneData(oL.oData, bOverlay);
        }
    }

    /*   -----------------------------------------------------------------   */

    findMinMaxFromStore()
    {
    this.dMin      = this.props.oData.min == undefined? 0 : this.props.oData.min; //Math.min(...this.oPoints);
    this.dMax      = this.props.oData.max == undefined? 0 : this.props.oData.max;//Math.max(...this.oPoints);

    this.dMean     = (this.dMin + this.dMax)/2;
    }

    /*   -----------------------------------------------------------------   */

    findMinMaxFromData(oMin      : number[], 
                       oMax      : number[], 
                       bOverlay? : boolean)
    {
    if (oMin.length != oMax.length)
      return;

    if (bOverlay)
      {
      for (let i = 0; i < oMin.length; i++)
        {
        if (oMin[i] != undefined && this.dMin > oMin[i])
          this.dMin = oMin[i];

        if (oMax[i] != undefined && this.dMax < oMax[i])
          this.dMax = oMax[i];                    
        }

      /*   -------------------------------------------------------   */
          
      this.dMean = (this.dMin + this.dMax)/2;
      }
    else
      {
      let bMin = false;
      let bMax = false;

      for (let i = 0; i < oMin.length; i++)
        {
        if (oMin[i] != undefined && (this.dMin2 > oMin[i] || bMin == false))
          {
          this.dMin2 = oMin[i];
          bMin       = true;
          }

        if (oMax[i] != undefined && (this.dMax2 < oMax[i] || bMax == false))
          {
          this.dMax2 = oMax[i];                    
          bMax       = true;
          }
        }

      /*   -------------------------------------------------------   */
          
      this.dMean2 = (this.dMin2 + this.dMax2)/2;
      }
    }

    /*   -----------------------------------------------------------------   */

    findMinMaxFromTwoData(oData1    : number[], 
                          oData2    : number[],
                          bOverlay? : boolean)
    {
    if (oData1.length != oData2.length)
      return;

    if (bOverlay)
      {
      for (let i = 0; i < oData1.length; i++)
        {
          if (oData1[i] != undefined)
            {
            if (this.dMin > oData1[i])
              this.dMin = oData1[i];
            else if (this.dMax < oData1[i])
              this.dMax = oData1[i];
            }

          if (oData2[i] != undefined)
            {
            if (this.dMin > oData2[i])
              this.dMin = oData2[i];
            else if (this.dMax < oData2[i])
              this.dMax = oData2[i];
            }
        }

      /*   -----------------------------------------------------   */
          
      this.dMean = (this.dMin + this.dMax)/2;
      }
    else
      {
      let bMin = false;

      for (let i = 0; i < oData1.length; i++)
        {
          if (oData1[i] != undefined)
            {
            if (bMin == false)
              {
              this.dMin2 = oData1[i];
              this.dMax2 = oData1[i];
              bMin       = true;
              }
            else if (this.dMin2 > oData1[i])
              this.dMin2 = oData1[i];
            else if (this.dMax2 < oData1[i])
              this.dMax2 = oData1[i];
            }

          if (oData2[i] != undefined)
            {
            if (bMin == false)
              {
              this.dMin2 = oData2[i];
              this.dMax2 = oData2[i];
              bMin       = true;
              }
            else if (this.dMin2 > oData2[i])
              this.dMin2 = oData2[i];
            else if (this.dMax2 < oData2[i])
              this.dMax2 = oData2[i];
            }
        }

      /*   -----------------------------------------------------   */
          
      this.dMean2 = (this.dMin2 + this.dMax2)/2;
      }
    }

    /*   -----------------------------------------------------------------   */

    findMinMaxFromOneData(oData1  : number[],
                          bOverlay: boolean | undefined)
    {
    if (bOverlay)
      {
      for (let i = 0; i < oData1.length; i++)
        {
          if (oData1[i] != undefined)
            {
            if (this.dMin > oData1[i])
              this.dMin = oData1[i];
            else if (this.dMax < oData1[i])
              this.dMax = oData1[i];
            }
        }

      /*   -------------------------------------------------------   */
          
      this.dMean = (this.dMin + this.dMax)/2;
      }
    else
      {
      let bMin = false;

      for (let i = 0; i < oData1.length; i++)
        {
          if (oData1[i] != undefined)
            {
            if (bMin == false)
              {
              this.dMin2 = oData1[i];
              this.dMax2 = oData1[i];
              bMin       = true;
              }
            else if (this.dMin2 > oData1[i])
              this.dMin2 = oData1[i];
            else if (this.dMax2 < oData1[i])
              this.dMax2 = oData1[i];
            }
        }

      /*   -------------------------------------------------------   */
          
      this.dMean2 = (this.dMin2 + this.dMax2)/2;
      }
    }

    /*   -----------------------------------------------------------------   */

    initThreeValues(oInd: IIndicator,
                    oL1 : number[],
                    oL2 : number[],
                    oL3 : number[])
    {
    if (oInd.oL1.oData == undefined)
      oInd.oL1.oData = new Array(this.oPoints.length);
    else
      oInd.oL1.oData.splice(0, oInd.oL1.oData.length);

    /*   -----------------------------------------------------------------   */

    if (oInd.oL2.oData == undefined)            
      oInd.oL2.oData = new Array(this.oPoints.length);
    else
      oInd.oL2.oData.splice(0, oInd.oL2.oData.length);

    /*   -----------------------------------------------------------------   */      

    if (oInd.oL3.oData == undefined)            
      oInd.oL3.oData = new Array(this.oPoints.length);
    else
      oInd.oL3.oData.splice(0, oInd.oL3.oData.length);

    /*   -----------------------------------------------------------------   */

    //Init and populate ind values
    if (oL2 == undefined)
      return;

    /*   -----------------------------------------------------------   */         

    if (oInd.bOverlay)
      {
      for (let i = oInd.oL1.iPeriod - 1; i < this.oPoints.length; i++)
          {
          oInd.oL1.oData[i] = oL1[i]; //.lowerBand[i];

          oInd.oL2.oData[i] = oL2[i];  //middleBand[i];
          oInd.oL3.oData[i] = oL3[i]; //upperBand[i];

          if (oInd.oL2.oData[i] != undefined && 
              this.dMin         > oInd.oL2.oData[i])
            this.dMin = oInd.oL2.oData[i];

          if (oInd.oL3.oData[i] != undefined && 
              this.dMax         < oInd.oL3.oData[i])
            this.dMax = oInd.oL3.oData[i];
          }

      /*   -----------------------------------------------------------   */

      this.dMean = (this.dMin + this.dMax)/2;
      }
    else
      {
      let bMin = false;
      let bMax = false;

      //check here
      //this.oPoints.length > oInd.oL1.iPeriod - 1

      for (let i = 0; i < this.oPoints.length; i++)
        {
        oInd.oL1.oData[i] = oL1[i]; //.lowerBand[i];

        oInd.oL2.oData[i] = oL2[i];  //middleBand[i];
        oInd.oL3.oData[i] = oL3[i]; //upperBand[i];

        if (oInd.oL2.oData[i] != undefined && 
            (this.dMin2         > oInd.oL2.oData[i] || bMin == false))
          {
          this.dMin2 = oInd.oL2.oData[i];
          bMin       = true;
          }

        if (oInd.oL3.oData[i] != undefined && 
            (this.dMax2         < oInd.oL3.oData[i] || bMax == false))
          {
          this.dMax2 = oInd.oL3.oData[i];
          bMax       = true;
          }
        }

      /*   -----------------------------------------------------------   */

      this.dMean2 = (this.dMin2 + this.dMax2)/2;
      }
    }

    /*   -----------------------------------------------------------------   */

    initTwoValues(oInd: IIndicator,
                  oL1 : number[],
                  oL2 : number[])
    {
    if (oInd.oL1.oData == undefined)
      oInd.oL1.oData = new Array(this.oPoints.length);
    else
      oInd.oL1.oData.splice(0, oInd.oL1.oData.length);

    /*   -----------------------------------------------------------------   */

    if (oInd.oL2.oData == undefined)            
      oInd.oL2.oData = new Array(this.oPoints.length);
    else
      oInd.oL2.oData.splice(0, oInd.oL2.oData.length);

    /*   -----------------------------------------------------------------   */      

    //Init and populate ind values
    if (oL2 == undefined)
      return;

    /*   -----------------------------------------------------------   */         

    if (oInd.bOverlay)
      {
      for (let i = oInd.oL1.iPeriod - 1; i < this.oPoints.length; i++)
          {
          oInd.oL1.oData[i] = oL1[i];
          oInd.oL2.oData[i] = oL2[i];

          if (oInd.oL1.oData[i] != undefined)
            {
            if (this.dMin > oInd.oL1.oData[i])
              this.dMin = oInd.oL1.oData[i];
            else if (this.dMax < oInd.oL1.oData[i])
              this.dMax = oInd.oL1.oData[i];
            }

          if (oInd.oL2.oData[i] != undefined)
            {
            if (this.dMin > oInd.oL2.oData[i])
              this.dMin = oInd.oL2.oData[i];
            else if (this.dMax < oInd.oL2.oData[i])
              this.dMax = oInd.oL2.oData[i];
            }
          }

      /*   -----------------------------------------------------------   */

      this.dMean = (this.dMin + this.dMax)/2;
      }
    else
      {
      let bMin = false;

      for (let i = 0; i < this.oPoints.length; i++)
        {
        oInd.oL1.oData[i] = Number.isNaN(oL1[i])? 0 : oL1[i];
        oInd.oL2.oData[i] = Number.isNaN(oL2[i])? 0 : oL2[i];

        if (oInd.oL1.oData[i] != undefined)
          {
          if (bMin == false)
            {
            this.dMin2 = oInd.oL1.oData[i];
            this.dMax2 = oInd.oL1.oData[i];
            bMin       = true;
            }  
          else if (this.dMin2 > oInd.oL1.oData[i])
            this.dMin2 = oInd.oL1.oData[i];
          else if (this.dMax2 < oInd.oL1.oData[i])
            this.dMax2 = oInd.oL1.oData[i];
          }

        if (oInd.oL2.oData[i] != undefined)
          {
          if (bMin == false)
            {
            this.dMin2 = oInd.oL2.oData[i];
            this.dMax2 = oInd.oL2.oData[i];
            bMin       = true;
            }  
          else if (this.dMin2 > oInd.oL2.oData[i])
            this.dMin2 = oInd.oL2.oData[i];
          else if (this.dMax2 < oInd.oL2.oData[i])
            this.dMax2 = oInd.oL2.oData[i];
          }
        }

      /*   -----------------------------------------------------------   */

      this.dMean2 = (this.dMin2 + this.dMax2)/2;
      }
    }

    /*   -----------------------------------------------------------------   */

    initOneValues(oInd  : IIndicator,
                  oL1   : number[])
    {
    if (oInd.oL1.oData == undefined)
      oInd.oL1.oData = new Array(this.oPoints.length);
    else
      oInd.oL1.oData.splice(0, oInd.oL1.oData.length);

    /*   -----------------------------------------------------------------   */

    if (oInd.bOverlay)
      {
      for (let i = oInd.oL1.iPeriod - 1; i < this.oPoints.length; i++)
          {
          oInd.oL1.oData[i] = oL1[i];

          if (oInd.oL1.oData[i] != undefined)
            {
            if (this.dMin > oInd.oL1.oData[i])
              this.dMin = oInd.oL1.oData[i];
            else if (this.dMax < oInd.oL1.oData[i])
              this.dMax = oInd.oL1.oData[i];
            }
          }

      /*   -----------------------------------------------------------   */

      this.dMean = (this.dMin + this.dMax)/2;
      }
    else
      {
      let bMin = false;

      for (let i = 0; i < this.oPoints.length; i++) //starting with 0 is needed to match-up the overlayed chart
        {
        oInd.oL1.oData[i] = Number.isNaN(oL1[i]) ? 0 : oL1[i];

        if (oInd.oL1.oData[i] != undefined)
          {
          if (bMin == false)
            {
            this.dMin2 = oInd.oL1.oData[i];
            this.dMax2 = oInd.oL1.oData[i];
            bMin       = true;
            }  
          else if (this.dMin2 > oInd.oL1.oData[i])
            this.dMin2 = oInd.oL1.oData[i];
          else if (this.dMax2 < oInd.oL1.oData[i])
            this.dMax2 = oInd.oL1.oData[i];
          }
        }

      /*   -----------------------------------------------------------   */

      this.dMean2 = (this.dMin2 + this.dMax2)/2;
      }
    }

    /*   -----------------------------------------------------------------   */

    updateThreeValues(oInd: IIndicator,
                      oL1 : number[],
                      oL2 : number[],
                      oL3 : number[])
    {
    if (oL2 == undefined)
      return;

    /*   -----------------------------------------------------------------   */

    if (!oInd.oL1.oData || !oInd.oL2.oData || !oInd.oL3.oData)
      return;

    /*   -----------------------------------------------------------------   */

    oInd.oL1.oData.push(oL1[oL1.length - 1]);  
    oInd.oL2.oData.push(oL2[oL2.length - 1]);  
    oInd.oL3.oData.push(oL3[oL3.length - 1]);

    /*   -----------------------------------------------------------------   */

    //remove the first point to adjust overflow
    if (oInd.oL1.oData.length > this.props.oData.lookback.Max) 
      {
      oInd.oL1.oData.splice(0, 1);
      oInd.oL2.oData.splice(0, 1);
      oInd.oL3.oData.splice(0, 1);
      }

    /*   -----------------------------------------------------------------   */

    this.findMinMaxFromData(oInd.oL2.oData, oInd.oL3.oData, oInd.bOverlay);
    }

    /*   -----------------------------------------------------------------   */

    updateTwoValues(oInd: IIndicator,
                    oL1 : number[],
                    oL2 : number[])
    {
    if (oL2 == undefined)
      return;

    /*   -----------------------------------------------------------------   */

    if (!oInd.oL1.oData || !oInd.oL2.oData)
      return;

    /*   -----------------------------------------------------------------   */

    oInd.oL1.oData.push(Number.isNaN(oL1[oL1.length - 1])? 0 : oL1[oL1.length - 1]);  
    oInd.oL2.oData.push(Number.isNaN(oL2[oL2.length - 1])? 0 : oL2[oL2.length - 1]);  

    /*   -----------------------------------------------------------------   */

    //remove the first point to adjust overflow
    if (oInd.oL1.oData.length > this.props.oData.lookback.Max) 
      {
      oInd.oL1.oData.splice(0, 1);
      oInd.oL2.oData.splice(0, 1);
      }

    /*   -----------------------------------------------------------------   */

    this.findMinMaxFromTwoData(oInd.oL1.oData, oInd.oL2.oData, oInd.bOverlay);
    }

    /*   -----------------------------------------------------------------   */

    updateOneValues(oInd: IIndicator,
                    oL1 : number[])
    {
    if (oL1 == undefined)
      return;

    /*   -----------------------------------------------------------------   */

    if (!oInd.oL1.oData)
      return;

    /*   -----------------------------------------------------------------   */

    oInd.oL1.oData.push(Number.isNaN(oL1[oL1.length - 1])? 0 : oL1[oL1.length - 1]);  

    /*   -----------------------------------------------------------------   */

    //remove the first point to adjust overflow
    if (oInd.oL1.oData.length > this.props.oData.lookback.Max) 
      {
      oInd.oL1.oData.splice(0, 1);
      }

    /*   -----------------------------------------------------------------   */

    this.findMinMaxFromData(oInd.oL1.oData, oInd.oL1.oData, oInd.bOverlay);
    }

    /*   -----------------------------------------------------------------   */

    IsThreeInit(oInd : IIndicator)
    {
      return (
              this.props.oData.update_chart_rr ||
              !oInd.oL1.oData                  || 
              !oInd.oL2.oData                  || 
              !oInd.oL3.oData);
    }

    /*   -----------------------------------------------------------------   */

    IsTwoInit(oInd : IIndicator)
    {
      return (
              this.props.oData.update_chart_rr ||
              !oInd.oL1.oData                  || 
              !oInd.oL2.oData                  ||
              (!oInd.bOverlay && 
                (oInd.oL1.oData.length < oInd.oL1.iPeriod - 1 || 
                 oInd.oL2.oData.length < oInd.oL2.iPeriod - 1 ) ));
    }

    /*   -----------------------------------------------------------------   */

    IsOneInit(oInd : IIndicator)
    {
      return (
              this.props.oData.update_chart_rr ||
              !oInd.oL1.oData                  ||
              (!oInd.bOverlay && 
               oInd.oL1.oData.length < oInd.oL1.iPeriod - 1 ));
    }

    /*   -----------------------------------------------------------------   */

    getPoints(oInd   : IIndicator,
              oPoints: number[])
    {
    if (oPoints.length >= oInd.oL1.iPeriod)
        return oPoints.slice(oPoints.length - oInd.oL1.iPeriod);
    else
        return oPoints;
    }

    /*   -----------------------------------------------------------------   */

    static slicePoints(iPeriod: number,
                       oPoints: number[])
    {
      if (oPoints.length >= iPeriod)
        return oPoints.slice(oPoints.length - iPeriod);
    else
        return oPoints;
    }

    /*   -----------------------------------------------------------------   */

    updateThreeEmptyValues(oInd : IIndicator)
    {
    if (!oInd.oL1.oData)
      return(true);

    if (oInd.oL1.oData.length < oInd.oL1.iPeriod - 1)
      {
      if (oInd.oL1.oData.length < this.props.oData.lookback.Max)
        {
        oInd.oL1.oData = new Array(this.oPoints.length);
        oInd.oL2.oData = new Array(this.oPoints.length);
        oInd.oL3.oData = new Array(this.oPoints.length);
        }

      return(true);
      }

    return(false);
    }

    /*   -----------------------------------------------------------------   */

    updateTwoEmptyValues(oInd : IIndicator)
    {
    if (!oInd.oL1.oData || !oInd.oL2.oData)
      return(true);

    if (oInd.oL1.oData.length < oInd.oL1.iPeriod - 1)
      {
      if (oInd.oL1.oData.length < this.props.oData.lookback.Max)
        {
        //if (oInd.bOverlay)
          {
          oInd.oL1.oData = new Array(this.oPoints.length);
          oInd.oL2.oData = new Array(this.oPoints.length);
          }
        //else
          {
          // oInd.oL1.oData.length  = this.oPoints.length;
          // oInd.oL2.oData.length  = this.oPoints.length;
          }
        }

      return(true);
      }

    return(false);
    }

    /*   -----------------------------------------------------------------   */

    updateOneEmptyValues(oL : ILine)
    {
    if (!oL.oData)
      return(true);

    if (oL.oData.length < oL.iPeriod - 1)
      {
      if (oL.oData.length < this.props.oData.lookback.Max)
        {
        oL.oData = new Array(this.oPoints.length);
        }

      return(true);
      }

    return(false);
    }

    /*   -----------------------------------------------------------------   */

    setIndicatorValuesAll()
    {
    for (let i = 0; i < this.oIndicators.length; i++)
      this.setIndicatorValues(this.oIndicators[i]);
    }

    /*   -----------------------------------------------------------------   */

    setIndicatorValues(oIndIn : IIndicator,
                       bForce : boolean = false)
    {
    if (!oIndIn.oL1.iPeriod || !this.oPoints.length)
      return;

    switch(oIndIn.iIndicator)
      {
      case IndicatorType.BB:
        if (bForce || this.IsThreeInit(oIndIn))
          {
          let oL1 = sma(oIndIn.oL1.iPeriod, this.oPoints);
          let oSD = multiplyBy(2, mstd(oIndIn.oL1.iPeriod, this.oPoints));

          this.initThreeValues(oIndIn, oL1, subtract(oL1, oSD), add(oL1, oSD));
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateThreeEmptyValues(oIndIn)) //calculate and add only the new point
            {
            let oPts = this.getPoints(oIndIn, this.oPoints);
            let oL1  = sma(oIndIn.oL1.iPeriod, oPts);
            let oSD  = multiplyBy(2, mstd(oIndIn.oL1.iPeriod, oPts));

            this.updateThreeValues(oIndIn, oL1, subtract(oL1, oSD), add(oL1, oSD));
            }
          }
        break;
      case IndicatorType.DC:
        if (bForce || this.IsThreeInit(oIndIn))
          {
          let oL2 = mmax(oIndIn.oL1.iPeriod, this.props.oData.highs);
          let oL3 = mmin(oIndIn.oL1.iPeriod, this.props.oData.lows);
          this.initThreeValues(oIndIn, divideBy(2, add(oL2, oL3)), oL2, oL3);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateThreeEmptyValues(oIndIn)) //calculate and add only the new point
            {
            let oL2 = mmax(oIndIn.oL1.iPeriod, this.getPoints(oIndIn, this.props.oData.highs));
            let oL3 = mmin(oIndIn.oL1.iPeriod, this.getPoints(oIndIn, this.props.oData.lows));
            this.updateThreeValues(oIndIn, divideBy(2, add(oL2, oL3)), oL2, oL3);
            }
          }
        break;
      case IndicatorType.KC:
        if (bForce || this.IsThreeInit(oIndIn))
          {
          let oInd = keltnerChannel(oIndIn.oL1.iPeriod, this.props.oData.highs, this.props.oData.lows, this.props.oData.closes);
          this.initThreeValues(oIndIn, oInd.middleLine, oInd.lowerBand, oInd.upperBand);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateThreeEmptyValues(oIndIn)) //calculate and add only the new point
            {
            let oInd = keltnerChannel(oIndIn.oL1.iPeriod, this.getPoints(oIndIn, this.props.oData.highs), this.getPoints(oIndIn, this.props.oData.lows), this.getPoints(oIndIn, this.props.oData.closes));
            this.updateThreeValues(oIndIn, oInd.middleLine, oInd.lowerBand, oInd.upperBand);
            }
          }
        break;
      case IndicatorType.SMA:
        this.setSingleIndicator(oIndIn.oL1, sma, oIndIn.bOverlay, bForce);
        this.setSingleIndicator(oIndIn.oL2, sma, oIndIn.bOverlay, bForce);
        break;  
      case IndicatorType.EMA:
        this.setSingleIndicator(oIndIn.oL1, ema, oIndIn.bOverlay, bForce);
        this.setSingleIndicator(oIndIn.oL2, ema, oIndIn.bOverlay, bForce);
        break;
      case IndicatorType.TRIMA:
        this.setSingleIndicator(oIndIn.oL1, trima, oIndIn.bOverlay, bForce);
        this.setSingleIndicator(oIndIn.oL2, trima, oIndIn.bOverlay, bForce);
        break;
      case IndicatorType.ATR:
        //alert (this.props.oData.highs.length  + " " + oIndIn.oL1.iPeriod + " " + this.oPoints[0]);

        if (bForce || this.IsTwoInit(oIndIn))
          {
          let oInd = atr(oIndIn.oL1.iPeriod, this.props.oData.highs, this.props.oData.lows, this.props.oData.closes);
          this.initTwoValues(oIndIn, oInd.atrLine, oInd.trLine);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateTwoEmptyValues(oIndIn)) //calculate and add only the new point
            {
            let oInd = atr(oIndIn.oL1.iPeriod, 
                           this.getPoints(oIndIn, this.props.oData.highs), 
                           this.getPoints(oIndIn, this.props.oData.lows), 
                           this.getPoints(oIndIn, this.props.oData.closes));
            this.updateTwoValues(oIndIn, oInd.atrLine, oInd.trLine);
            }
          }
        break;
      case IndicatorType.RSI:
        this.setSingleIndicator(oIndIn.oL1, ChartEx.customRsi, oIndIn.bOverlay, bForce);
        // if (bForce || this.IsOneInit(oIndIn))
        //   {
        //   let oInd : number[] = customRsi(oIndIn.oL1.iPeriod, this.props.oData.closes);

        //   this.initOneValues(oIndIn, oInd);
        //   }
        // else if (this.props.oData.update_chart) //new data added
        //   {
        //   if (!this.updateOneEmptyValues(oIndIn.oL1)) //calculate and add only the new point
        //     {
        //     let oInd = customRsi(oIndIn.oL1.iPeriod, 
        //                          this.getPoints(oIndIn, this.props.oData.closes));

        //     this.updateOneValues(oIndIn, oInd);
        //     }
        //   }
        break;
      case IndicatorType.DEMA:
        this.setSingleIndicator(oIndIn.oL1, dema, oIndIn.bOverlay, bForce);
        this.setSingleIndicator(oIndIn.oL2, dema, oIndIn.bOverlay, bForce);
        break;
      case IndicatorType.TEMA:
        this.setSingleIndicator(oIndIn.oL1, tema, oIndIn.bOverlay, bForce);
        this.setSingleIndicator(oIndIn.oL2, tema, oIndIn.bOverlay, bForce);
        break;
      case IndicatorType.TRIX:
        this.setSingleIndicator(oIndIn.oL1, trix, oIndIn.bOverlay, bForce);
        break;
      case IndicatorType.CMI:
        if (bForce || this.IsOneInit(oIndIn))
          {
          let oInd : number[] = ChartEx.communityChannelIndex(oIndIn.oL1.iPeriod, 
                                                              this.props.oData.highs,
                                                              this.props.oData.lows,
                                                              this.props.oData.closes);

          this.initOneValues(oIndIn, oInd);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateOneEmptyValues(oIndIn.oL1)) //calculate and add only the new point
            {
            let oInd = ChartEx.communityChannelIndex(oIndIn.oL1.iPeriod, 
                                                     this.getPoints(oIndIn, this.props.oData.highs),
                                                     this.getPoints(oIndIn, this.props.oData.lows),
                                                     this.getPoints(oIndIn, this.props.oData.closes));

            this.updateOneValues(oIndIn, oInd);
            }
          }
        break;   
      case IndicatorType.MACD:
        if (bForce || this.IsTwoInit(oIndIn))
          {
          let oInd = ChartEx.macd(oIndIn.oL1.iPeriod, oIndIn.oL2.iPeriod, oIndIn.oL3.iPeriod, this.props.oData.closes);
          this.initTwoValues(oIndIn, oInd.macdLine, oInd.signalLine);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateTwoEmptyValues(oIndIn)) //calculate and add only the new point
            {
            let oInd = ChartEx.macd(oIndIn.oL1.iPeriod, 
                                    oIndIn.oL2.iPeriod, 
                                    oIndIn.oL3.iPeriod, 
                                    this.getPoints(oIndIn, this.props.oData.closes));
            this.updateTwoValues(oIndIn, oInd.macdLine, oInd.signalLine);
            }
          }
        break;
      case IndicatorType.RMA:
        this.setSingleIndicator(oIndIn.oL1, rma, oIndIn.bOverlay, bForce);
        this.setSingleIndicator(oIndIn.oL2, rma, oIndIn.bOverlay, bForce);
        break;
      case IndicatorType.TP:
        if (bForce || this.IsOneInit(oIndIn))
          {
          //oIndIn.oL1.iPeriod  = 1;

          let oInd : number[] = typicalPrice(this.props.oData.highs,
                                             this.props.oData.lows,
                                             this.props.oData.closes);

          this.initOneValues(oIndIn, oInd);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateOneEmptyValues(oIndIn.oL1)) //calculate and add only the new point
            {
            let oInd = typicalPrice(this.getPoints(oIndIn, this.props.oData.highs),
                                    this.getPoints(oIndIn, this.props.oData.lows),
                                    this.getPoints(oIndIn, this.props.oData.closes));

            this.updateOneValues(oIndIn, oInd);
            }
          }
        break;
      case IndicatorType.AO:
        if (bForce || this.IsOneInit(oIndIn))
          {
          let oInd : number[] = ChartEx.awesomeOscillator(oIndIn.oL1.iPeriod,
                                                          oIndIn.oL2.iPeriod,
                                                          this.props.oData.highs,
                                                          this.props.oData.lows);

          this.initOneValues(oIndIn, oInd);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateOneEmptyValues(oIndIn.oL1)) //calculate and add only the new point
            {
            let oInd = ChartEx.awesomeOscillator(oIndIn.oL1.iPeriod,
                                                 oIndIn.oL2.iPeriod,
                                                 this.getPoints(oIndIn, this.props.oData.highs),
                                                 this.getPoints(oIndIn, this.props.oData.lows));

            this.updateOneValues(oIndIn, oInd);
            }
          }
        break;
      case IndicatorType.CO: //check 1, 5 min
        if (bForce || this.IsTwoInit(oIndIn))
          {
          let oInd = ChartEx.chaikinOscillator(oIndIn.oL2.iPeriod,
                                               oIndIn.oL1.iPeriod,
                                               this.props.oData.highs,
                                               this.props.oData.lows,
                                               this.props.oData.closes,
                                               this.props.oData.vols);

          // for (let i = 0; i < oIndIn.oL2.iPeriod; i++)
          //   oInd[i] = 0;
                           
          this.initTwoValues(oIndIn, oInd.co, oInd.ad);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateTwoEmptyValues(oIndIn)) //calculate and add only the new point
            {
            // let oInd = chaikinOscillator(oIndIn.oL2.iPeriod,
            //                             oIndIn.oL1.iPeriod,
            //                             this.props.oData.highs,
            //                             this.props.oData.lows,
            //                             this.props.oData.closes,
            //                             this.props.oData.vols);

            // for (let i = 0; i < oIndIn.oL2.iPeriod; i++)
            //   oInd[i] = 0;
                            
            // this.initTwoValues(oIndIn, oInd.co, oInd.ad);

            let oInd = ChartEx.chaikinOscillator(oIndIn.oL2.iPeriod, //07-> fast
                                                 oIndIn.oL1.iPeriod, //14-> slow
                                                 this.getPoints(oIndIn, this.props.oData.highs),
                                                 this.getPoints(oIndIn, this.props.oData.lows),
                                                 this.getPoints(oIndIn, this.props.oData.closes),
                                                 this.getPoints(oIndIn, this.props.oData.vols)                              
                                                 );

            // for (let i = 0; i < oIndIn.oL1.iPeriod; i++)
            //   oInd[i] = 0;

            this.updateTwoValues(oIndIn, oInd.co, oInd.ad);
            }
          }
        break;
      case IndicatorType.PPO:
        if (bForce || this.IsTwoInit(oIndIn))
          {
          let oInd = ChartEx.percentagePriceOscillator(oIndIn.oL2.iPeriod, //fast
                                                       oIndIn.oL1.iPeriod, //slow
                                                       oIndIn.oL3.iPeriod, //signal pd
                                                       this.props.oData.closes);

          this.initTwoValues(oIndIn, oInd.ppo, oInd.signal);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateTwoEmptyValues(oIndIn)) //calculate and add only the new point
            {
            let oInd = ChartEx.percentagePriceOscillator(oIndIn.oL2.iPeriod, //07-> fast
                                                         oIndIn.oL1.iPeriod, //14-> slow
                                                         oIndIn.oL3.iPeriod, //03-> signal
                                                         this.getPoints(oIndIn, this.props.oData.closes)                            
                                                         );

            this.updateTwoValues(oIndIn, oInd.ppo, oInd.signal);
            }
          }
        break;
      case IndicatorType.SO:
        if (bForce || this.IsTwoInit(oIndIn))
          {
          let oInd = ChartEx.stochasticOscillator(oIndIn.oL1.iPeriod, //slow
                                                  oIndIn.oL2.iPeriod, //signal
                                                  this.props.oData.highs,
                                                  this.props.oData.lows,
                                                  this.props.oData.closes
                                                  );

          this.initTwoValues(oIndIn, oInd.so, oInd.so_slow);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateTwoEmptyValues(oIndIn)) //calculate and add only the new point
            {
            let oInd = ChartEx.stochasticOscillator(oIndIn.oL1.iPeriod, //14->slow
                                                    oIndIn.oL2.iPeriod, //03->signal
                                                    this.getPoints(oIndIn, this.props.oData.highs),
                                                    this.getPoints(oIndIn, this.props.oData.lows),
                                                    this.getPoints(oIndIn, this.props.oData.closes)
                                                    );

            this.updateTwoValues(oIndIn, oInd.so, oInd.so_slow);
            }
          }
        break;
      case IndicatorType.WR:
        if (bForce || this.IsOneInit(oIndIn))
          {
          let oInd = ChartEx.williamsR(oIndIn.oL1.iPeriod,
                                      this.props.oData.highs,
                                      this.props.oData.lows,
                                      this.props.oData.closes
                                      );

          this.initOneValues(oIndIn, oInd);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateOneEmptyValues(oIndIn.oL1)) //!this.updateTwoEmptyValues(oIndIn)) //calculate and add only the new point
            {
            let oInd = ChartEx.williamsR(oIndIn.oL1.iPeriod,
                                         this.getPoints(oIndIn, this.props.oData.highs),
                                         this.getPoints(oIndIn, this.props.oData.lows),
                                         this.getPoints(oIndIn, this.props.oData.closes)
                                         );

            this.updateOneValues(oIndIn, oInd);
            }
          }
        break;
      case IndicatorType.AB:
        if (bForce || this.IsThreeInit(oIndIn))
          {
          let oInd = ChartEx.accelerationBands(oIndIn.oL1.iPeriod,
                                               this.props.oData.highs,
                                               this.props.oData.lows,
                                               this.props.oData.closes
                                               );

          this.initThreeValues(oIndIn, oInd.middleBand, oInd.lowerBand, oInd.upperBand);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateThreeEmptyValues(oIndIn)) //calculate and add only the new point
            {
            let oInd = ChartEx.accelerationBands(oIndIn.oL1.iPeriod,
                                                 this.getPoints(oIndIn, this.props.oData.highs),
                                                 this.getPoints(oIndIn, this.props.oData.lows),
                                                 this.getPoints(oIndIn, this.props.oData.closes)
                                                 );

            this.updateThreeValues(oIndIn, oInd.middleBand, oInd.lowerBand, oInd.upperBand);
            }
          }
        break;
      case IndicatorType.PO:
        if (bForce || this.IsOneInit(oIndIn))
          {
          let oInd = ChartEx.projectionOscillator(oIndIn.oL1.iPeriod,
                                                  oIndIn.oL2.iPeriod,
                                                  this.props.oData.highs,
                                                  this.props.oData.lows,
                                                  this.props.oData.closes
                                                  );

          this.initTwoValues(oIndIn, oInd.po, oInd.spo);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateTwoEmptyValues(oIndIn)) //calculate and add only the new point
            {
            let oInd = ChartEx.projectionOscillator(oIndIn.oL1.iPeriod,
                                                    oIndIn.oL2.iPeriod,
                                                    this.getPoints(oIndIn, this.props.oData.highs),
                                                    this.getPoints(oIndIn, this.props.oData.lows),
                                                    this.getPoints(oIndIn, this.props.oData.closes)
                                                    );

            this.updateTwoValues(oIndIn, oInd.po, oInd.spo);
            }
          }
        break;
      case IndicatorType.AD:
        if (bForce || this.IsOneInit(oIndIn))
          {
          let oInd = ChartEx.accumulationDistribution(
                                              this.props.oData.highs,
                                              this.props.oData.lows,
                                              this.props.oData.closes,
                                              this.props.oData.vols
                                              );

          this.initOneValues(oIndIn, oInd);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateOneEmptyValues(oIndIn.oL1)) //calculate and add only the new point
            {
            let oInd = ChartEx.accumulationDistribution(
                                                this.getPoints(oIndIn, this.props.oData.highs),
                                                this.getPoints(oIndIn, this.props.oData.lows),
                                                this.getPoints(oIndIn, this.props.oData.closes),
                                                this.getPoints(oIndIn, this.props.oData.vols)
                                                );

            this.updateOneValues(oIndIn, oInd);
            }
          }
        break;
      case IndicatorType.CMF: //check 1, 5 min
        if (bForce || this.IsOneInit(oIndIn))
          {
          let oInd = ChartEx.chaikinMoneyFlow(
                                              oIndIn.oL1.iPeriod,
                                              this.props.oData.highs,
                                              this.props.oData.lows,
                                              this.props.oData.closes,
                                              this.props.oData.vols
                                              );

          this.initOneValues(oIndIn, oInd);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateOneEmptyValues(oIndIn.oL1)) //calculate and add only the new point
            {
            let oInd = ChartEx.chaikinMoneyFlow(
                                                oIndIn.oL1.iPeriod,
                                                this.getPoints(oIndIn, this.props.oData.highs),
                                                this.getPoints(oIndIn, this.props.oData.lows),
                                                this.getPoints(oIndIn, this.props.oData.closes),
                                                this.getPoints(oIndIn, this.props.oData.vols)
                                                );

            this.updateOneValues(oIndIn, oInd);
            }
          }
        break;
      case IndicatorType.EMV:
        if (bForce || this.IsOneInit(oIndIn))
          {
          let oInd = ChartEx.easeOfMovement(
                                            oIndIn.oL1.iPeriod,
                                            this.props.oData.highs,
                                            this.props.oData.lows,
                                            this.props.oData.vols
                                            );

          // for (let i = 0; i < oIndIn.oL1.iPeriod; i++)
          //   oInd[i] = 0;

          this.initOneValues(oIndIn, oInd);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateOneEmptyValues(oIndIn.oL1)) //calculate and add only the new point
            {
            let oInd = ChartEx.easeOfMovement(
                                              oIndIn.oL1.iPeriod,
                                              this.props.oData.highs,
                                              this.props.oData.lows,
                                              this.props.oData.vols
                                              //calculate for the whole data, partial data giving large values for some unknown reason.
                                              // this.getPoints(oIndIn, this.props.oData.highs),
                                              // this.getPoints(oIndIn, this.props.oData.lows),
                                              // this.getPoints(oIndIn, this.props.oData.vols)
                                              );

            this.updateOneValues(oIndIn, oInd);
            }
          }
        break;
      case IndicatorType.FI:
        if (bForce || this.IsOneInit(oIndIn))
          {
          let oInd = ChartEx.forceIndex(
                                        oIndIn.oL1.iPeriod,
                                        this.props.oData.closes,
                                        this.props.oData.vols
                                        );

          // for (let i = 0; i < oIndIn.oL1.iPeriod; i++)
          //   oInd[i] = 0;

          this.initOneValues(oIndIn, oInd);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateOneEmptyValues(oIndIn.oL1)) //calculate and add only the new point
            {
            let oInd = ChartEx.forceIndex(
                                          oIndIn.oL1.iPeriod,
                                          this.props.oData.closes,
                                          this.props.oData.vols
                                          //calculate for the whole data, partial data giving descending large values for some unknown reason.
                                          // this.getPoints(oIndIn, this.props.oData.highs),
                                          // this.getPoints(oIndIn, this.props.oData.lows),
                                          );

            this.updateOneValues(oIndIn, oInd);
            }
          }
        break;
      case IndicatorType.MFI:
        if (bForce || this.IsOneInit(oIndIn))
          {
          let oInd = ChartEx.moneyFlowIndex(
                                            oIndIn.oL1.iPeriod,
                                            this.props.oData.highs,
                                            this.props.oData.lows,
                                            this.props.oData.closes,
                                            this.props.oData.vols
                                            );

          this.initOneValues(oIndIn, oInd);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateOneEmptyValues(oIndIn.oL1)) //calculate and add only the new point
            {
            let oInd = ChartEx.moneyFlowIndex(
                                              oIndIn.oL1.iPeriod,
                                              this.getPoints(oIndIn, this.props.oData.highs),
                                              this.getPoints(oIndIn, this.props.oData.lows),
                                              this.getPoints(oIndIn, this.props.oData.closes),
                                              this.getPoints(oIndIn, this.props.oData.vols)
                                              );

            this.updateOneValues(oIndIn, oInd);
            }
          }
        break;
      case IndicatorType.OBV:
        if (bForce || this.IsOneInit(oIndIn))
          {
          let oInd = ChartEx.onBalanceVolume(
                                    this.props.oData.closes,
                                    this.props.oData.vols
                                    );

          this.initOneValues(oIndIn, oInd);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateOneEmptyValues(oIndIn.oL1)) //calculate and add only the new point
            {
            let oInd = ChartEx.onBalanceVolume(
                                              this.props.oData.closes,
                                              this.props.oData.vols
                                              //obv is a continuous indicator which is built on previous values. So it cannot be partially calculated. We always calculate with the whole data.
                                              //ChartEx.slicePoints(5, this.props.oData.closes),
                                              //ChartEx.slicePoints(5, this.props.oData.vols)
                                              );

            this.updateOneValues(oIndIn, oInd);
            }
          }
        break;
      case IndicatorType.VPT:
        if (bForce || this.IsOneInit(oIndIn))
          {
          let oInd = ChartEx.volumePriceTrend(
                                              this.props.oData.closes,
                                              this.props.oData.vols
                                              );

          this.initOneValues(oIndIn, oInd);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateOneEmptyValues(oIndIn.oL1)) //calculate and add only the new point
            {
            let oInd = ChartEx.volumePriceTrend(
                                                this.getPoints(oIndIn, this.props.oData.closes),
                                                this.getPoints(oIndIn, this.props.oData.vols)
                                                );

            this.updateOneValues(oIndIn, oInd);
            }
          }
        break;
      case IndicatorType.VOL:
        if (bForce || this.IsOneInit(oIndIn))
          {
          this.initOneValues(oIndIn, this.props.oData.vols);
          }
        else if (this.props.oData.update_chart) //new data added
          {
          if (!this.updateOneEmptyValues(oIndIn.oL1)) //calculate and add only the new point
            {
            let oInd = this.getPoints(oIndIn, this.props.oData.vols);

            this.updateOneValues(oIndIn, oInd);
            }
          }
        break;
      }
    }

    /*   -----------------------------------------------------------------   */

    static onBalanceVolume(
                            closings: number[],
                            volumes: number[]
                          ): number[] 
    {
      checkSameLength(closings, volumes);
    
      const result = new Array<number>(closings.length);
    
      for (let i = 0; i < result.length; i++) 
        {
        if (i === 0) 
          {
          result[i] = 0;
          } 
        else 
          {
          result[i] = result[i - 1];
    
          if (closings[i] > closings[i - 1]) 
            {
            result[i] += volumes[i];
            }
          else if (closings[i] < closings[i - 1]) 
            {
            result[i] -= volumes[i];
            }
          }
        }
    
      return result;
    }

    /*   -----------------------------------------------------------------   */

    static forceIndex(
                      period: number,
                      closings: number[],
                      volumes: number[]
                     ) 
    {
      const diff = ChartEx.changes(1, closings);

      // if (diff?.length)
      //   diff[0] = 0;

      return ema(period, multiply(diff, volumes));
    }
    
    // static easeOfMovement(
    //   period: number,
    //   highs: number[],
    //   lows: number[],
    //   volumes: number[]
    // ): number[] {
    //   const distanceMoved = changes(1, divideBy(2, add(highs, lows)));
    //   const boxRatio = divide(divideBy(100000000, volumes), subtract(highs, lows));
    //   const emv = sma(period, divide(distanceMoved, boxRatio));
    //   return emv;
    // }

    /*   -----------------------------------------------------------------   */

    static divide(values1: number[], values2: number[]): number[] 
      {
      checkSameLength(values1, values2);
    
      const result = new Array<number>(values1.length);
    
      for (let i = 0; i < result.length; i++) 
        {
        result[i] = !values2[i]? 0 : values1[i] / values2[i];
        }
    
      return result;
      }

    /*   -----------------------------------------------------------------   */

    static changes(n: number, values: number[]) 
    {
      const diff = subtract(values, shiftRightBy(n, values));

      if (diff?.length)
        diff[0] = 0;

      return (diff);
    }

    /*   -----------------------------------------------------------------   */

    static customRsi(period: number, closings: number[]) 
    {
      const gains = new Array<number>(closings.length);
      const losses = new Array<number>(closings.length);
    
      gains[0] = losses[0] = 0;
    
      for (let i = 1; i < closings.length; i++) {
        const difference = closings[i] - closings[i - 1];
    
        if (difference > 0) {
          gains[i] = difference;
          losses[i] = 0;
        } else {
          losses[i] = -difference;
          gains[i] = 0;
        }
      }
    
      const meanGains = rma(period, gains);
      const meanLosses = rma(period, losses);
    
      const r = new Array<number>(closings.length);
      const rs = new Array<number>(closings.length);
    
      r[0] = rs[0] = 0;
    
      for (let i = 1; i < closings.length; i++) {
        rs[i] = !meanLosses[i]? 0 : meanGains[i] / meanLosses[i];
        r[i] = 100 - 100 / (1 + rs[i]);
      }
    
      return r;
    }

    /*   -----------------------------------------------------------------   */

    static easeOfMovement(
                          period: number,
                          highs: number[],
                          lows: number[],
                          volumes: number[]
                        ) 
    {
      const distanceMoved = ChartEx.changes(1, divideBy(2, add(highs, lows)));

      // if (distanceMoved?.length)
      //   distanceMoved[0] = 0;

      const boxRatio = ChartEx.divide(divideBy(100000000, volumes), subtract(highs, lows));
      const emv = sma(period, ChartEx.divide(distanceMoved, boxRatio));
      return emv;
    }

    /*   -----------------------------------------------------------------   */

    static volumePriceTrend(
                            closings: number[],
                            volumes: number[]
                          ) 
    {
      const previousClosings = shiftRightAndFillBy(1, closings[0], closings);
      const vpt = multiply(
        volumes,
        ChartEx.divide(subtract(closings, previousClosings), previousClosings)
      );

      return msum(vpt.length, vpt);
    }

    /*   -----------------------------------------------------------------   */

    static moneyFlowIndex
                          (
                            period: number,
                            highs: number[],
                            lows: number[],
                            closings: number[],
                            volumes: number[]
                          ) 
    {
      const rawMoneyFlow = multiply(typicalPrice(highs, lows, closings), volumes);

      const diff  = ChartEx.changes(1, rawMoneyFlow);

      // if (diff?.length)
      //   diff[0] = 0;

      const signs = extractSigns(diff);

      const moneyFlow = multiply(signs, rawMoneyFlow);
    
      const positiveMoneyFlow = moneyFlow.map((value) => (value >= 0 ? value : 0));
      const negativeMoneyFlow = moneyFlow.map((value) => (value < 0 ? value : 0));
    
      const moneyRatio = ChartEx.divide(
        msum(period, positiveMoneyFlow),
        msum(period, multiplyBy(-1, negativeMoneyFlow))
      );
    
      const moneyFlowIndex = addBy(
        100,
        multiplyBy(-100, pow(addBy(1, moneyRatio), -1))
      );
    
      return moneyFlowIndex;
    }

    /*   -----------------------------------------------------------------   */
    
    static communityChannelIndex
                                (
                                  period: number,
                                  highs: number[],
                                  lows: number[],
                                  closings: number[]
                                ) 
    {
      const tp = typicalPrice(highs, lows, closings);
      const ma = sma(period, tp);
      const md = sma(period, abs(subtract(tp, ma)));
      const cci = ChartEx.divide(subtract(tp, ma), multiplyBy(0.015, md));
      return cci;
    }

    /*   -----------------------------------------------------------------   */

    static projectionOscillator(
                                period: number,
                                smooth: number,
                                highs: number[],
                                lows: number[],
                                closings: number[]
                              )
    {
      const x = generateNumbers(0, closings.length, 1);
      const lsHighs = movingLeastSquare(period, x, highs);
      const lsLows = movingLeastSquare(period, x, lows);
    
      const vHighs = add(highs, multiply(lsHighs.m, x));
      const vLows = add(lows, multiply(lsLows.m, x));
    
      const pu = mmax(period, vHighs);
      const pl = mmin(period, vLows);
    
      const po = ChartEx.divide(multiplyBy(100, subtract(closings, pl)), subtract(pu, pl));
      const spo = ema(smooth, po);
    
      return {
        po,
        spo,
      };
    }

    /*   -----------------------------------------------------------------   */

    static percentagePriceOscillator(
                                    fastPeriod: number,
                                    slowPeriod: number,
                                    signalPeriod: number,
                                    prices: number[]
                                  )
      {
      const fastEma = ema(fastPeriod, prices);
      const slowEma = ema(slowPeriod, prices);
    
      const ppo = multiplyBy(100, ChartEx.divide(subtract(fastEma, slowEma), slowEma));
      const signal = ema(signalPeriod, ppo);
      const histogram = subtract(ppo, signal);
    
      return {
        ppo,
        signal,
        histogram,
      };
    }

    /*   -----------------------------------------------------------------   */

    static accumulationDistribution(
                                    highs: number[],
                                    lows: number[],
                                    closings: number[],
                                    volume: number[]
                                   )
    {
      const mfm = ChartEx.divide(
        subtract(subtract(closings, lows), subtract(highs, closings)),
        subtract(highs, lows)
      );
    
      const mfv = multiply(mfm, volume);
    
      const ad = new Array<number>(mfv.length);
    
      for (let i = 0; i < ad.length; i++) 
        {
        ad[i] = mfv[i];
        if (i > 0) 
          {
          ad[i] += ad[i - 1];
          }
        }
    
      return ad;
    }

    /*   -----------------------------------------------------------------   */

    static chaikinOscillator(
                              fastPeriod: number,
                              slowPeriod: number,
                              highs: number[],
                              lows: number[],
                              closings: number[],
                              volumes: number[]
                              ) 
      {
      const ad = ChartEx.accumulationDistribution(highs, lows, closings, volumes);
      const co = subtract(ema(fastPeriod, ad), ema(slowPeriod, ad));
    
      return {
        ad,
        co,
      };
    }

    /*   -----------------------------------------------------------------   */

    static chaikinMoneyFlow(
                            period: number,
                            highs: number[],
                            lows: number[],
                            closings: number[],
                            volumes: number[]
                            )
    {
    const moneyFlowMultipler = ChartEx.divide(
                                subtract(subtract(closings, lows), subtract(highs, closings)),
                                subtract(highs, lows)
                                );
  
    //ChartEx.removeNaN(moneyFlowMultipler);
    // if (moneyFlowMultipler?.length && isNaN(moneyFlowMultipler[0]))
    //   moneyFlowMultipler[0] = 0;

    const moneyFlowVolume = multiply(moneyFlowMultipler, volumes);
  
    const cmf = ChartEx.divide(
                        msum(period, moneyFlowVolume),
                        msum(period, volumes)
                      );
  
    return cmf;
    }

    /*   -----------------------------------------------------------------   */

    static removeNaN(values : number[])
    {
    for (let i = 0; i < values.length; i++)
      {
      if (Number.isNaN(values[i]))
        values[i] = 0;
      }
    }

    /*   -----------------------------------------------------------------   */

    static accelerationBands
                            (
                              period: number,
                              highs: number[],
                              lows: number[],
                              closings: number[]
                            ) 
    {
    checkSameLength(highs, lows, closings);
  
    const k = ChartEx.divide(subtract(highs, lows), add(highs, lows));
  
    const upperBand = sma(period, multiply(highs, addBy(1, multiplyBy(4, k))));
    const middleBand = sma(period, closings);
    const lowerBand = sma(period, multiply(lows, addBy(1, multiplyBy(-4, k))));
  
    return {
            upperBand,
            middleBand,
            lowerBand,
            };
    }

    /*   -----------------------------------------------------------------   */

    static williamsR (
                      period: number,
                      highs: number[],
                      lows: number[],
                      closings: number[]
                      ) 
    {
    const highestHigh = mmax(period, highs);
    const lowestLow = mmin(period, lows);

    return multiplyBy(
                      -100,
                      ChartEx.divide(subtract(highestHigh, closings), subtract(highestHigh, lowestLow))
                      );
    }

    /*   -----------------------------------------------------------------   */

    static stochasticOscillator(period: number ,
                                period_signal: number,
                                highs: number[],
                                lows: number[],
                                closings: number[]
                              ) 
    {
    const highestHigh14 = mmax(period, highs);
    const lowestLow14   = mmin(period, lows);
  
    const so = multiplyBy(
                          100,
                          ChartEx.divide(
                            subtract(closings, lowestLow14),
                            subtract(highestHigh14, lowestLow14)
                          )
                        );
  
    // if (so?.length && isNaN(so[0]))
    //     {                    
    //     so[0] = 0;
    //     }

    const so_slow = sma(period_signal, so);
  
    return {
      so,
      so_slow,
    };
    }

    /*   -----------------------------------------------------------------   */

    static awesomeOscillator(period_slow: number,
                             period_fast: number,
                             highs      : number[], 
                             lows       : number[]) : number[] 
    {
    const medianPrice = divideBy(2, add(lows, highs));
    const sma5 = sma(period_fast, medianPrice);
    const sma34 = sma(period_slow, medianPrice);
    const ao = subtract(sma5, sma34);
    return ao;
    }

    /*   -----------------------------------------------------------------   */

    static macd(period_slow   : number, //14
                period_fast   : number, //7
                period_signal : number, 
                closings      : number[])
    {
    const ema12 = ema(period_fast, closings);
    const ema26 = ema(period_slow, closings);
    
    const macdLine   = subtract(ema12, ema26);
    const signalLine = ema(period_signal, macdLine);
    
      return {
        macdLine,
        signalLine,
      };
    }

    /*   -----------------------------------------------------------------   */

    UpdateData()
    {
    if (this.props.oData.update_chart    || 
        this.props.oData.update_chart_rr ||
        this.props.oData.update_orders)
          {
          //this.props.oData.update_chart = false;

          this.findMinMaxFromStore();

          /*   -----------------------------------------------------------   */

          if (this.props.oData.update_orders == true || this.oCloses)
            {
            this.PopulateOrders();
            this.props.oData.update_orders = false;
            }

          /*   -----------------------------------------------------------   */

          //this.setState({points: [...this.props.oData.closes]});
          
          this.oPoints   = this.props.oData.closes;
          this.dDecimals = this.props.oData?.display_fmt? 3 : (this.props.oData?.f2qp > 6? 6 : this.props.oData?.f2qp), // optional, defaults to 2dp
          this.bChart    = (this.props.oData?.closes.length == 0 || (this.props.oData?.closes.length == 1 && this.props.oData?.closes[0] == 0) )? false : true;
          
          /*   -----------------------------------------------------------   */

          for (let i = 0; i < this.oIndicators.length; i++)
            this.setIndicatorValues(this.oIndicators[i]);

          /*   -----------------------------------------------------------   */

          this.props.oData.update_chart    = false;
          this.props.oData.update_chart_rr = false;

          /*   -----------------------------------------------------------   */

          // if (this.bChart == false)
          //   {
          //   this.forceUpdate();
          //   }

          this.forceUpdate();
          }
    }

    /*   -----------------------------------------------------------------   */

    UpdateDataOnLoad()
    {
    if (this.props.oData.update_chart    || 
        this.props.oData.update_chart_rr)
          {
          //this.props.oData.update_chart = false;

          this.findMinMaxFromStore();

          /*   -----------------------------------------------------------   */

          this.oPoints   = this.props.oData.closes;
          this.dDecimals = this.props.oData?.display_fmt? 3 : (this.props.oData?.f2qp > 6? 6 : this.props.oData?.f2qp), // optional, defaults to 2dp
          this.bChart    = (this.props.oData?.closes.length == 0 || (this.props.oData?.closes.length == 1 && this.props.oData?.closes[0] == 0) )? false : true;
          
          /*   -----------------------------------------------------------   */

          for (let i = 0; i < this.oIndicators.length; i++)
            this.setIndicatorValues(this.oIndicators[i]);

          /*   -----------------------------------------------------------   */

          this.props.oData.update_chart    = false;
          this.props.oData.update_chart_rr = false;
          }
    }

    /*   -----------------------------------------------------------------   */
    
    constructor(props)
    {
    super(props);

    this.UpdateData                 = this.UpdateData.bind(this);
    this.UpdateDataOnLoad           = this.UpdateDataOnLoad.bind(this);
    this.getFont                    = this.getFont.bind(this);
    this.getDotColor                = this.getDotColor.bind(this);
    this.SelectAccount              = this.SelectAccount.bind(this);
    this.SelectAccountForce         = this.SelectAccountForce.bind(this);
    this.GetData                    = this.GetData.bind(this);
    this.PopulateOrders             = this.PopulateOrders.bind(this);
    this.PopulateOrders2            = this.PopulateOrders2.bind(this);
    this.onOrderEvent               = this.onOrderEvent.bind(this);
    this.OnConfirmApply             = this.OnConfirmApply.bind(this);
        
    this.SetIndicatorLines          = this.SetIndicatorLines.bind(this);
    this.setIndicatorValues         = this.setIndicatorValues.bind(this);
        
    this.findMinMaxFromData         = this.findMinMaxFromData.bind(this);
    this.findMinMaxFromStore        = this.findMinMaxFromStore.bind(this);

    this.findMinMaxFromOneData      = this.findMinMaxFromOneData.bind(this);
    this.findMinMaxFromTwoData      = this.findMinMaxFromTwoData.bind(this);

    this.setSingleIndicator         = this.setSingleIndicator.bind(this);

    this.initOneValues              = this.initOneValues.bind(this);
    this.updateOneValues            = this.updateOneValues.bind(this);
    this.updateOneEmptyValues       = this.updateOneEmptyValues.bind(this);

    this.initTwoValues              = this.initTwoValues.bind(this);
    this.updateTwoValues            = this.updateTwoValues.bind(this);
    this.updateTwoEmptyValues       = this.updateTwoEmptyValues.bind(this);

    this.initThreeValues            = this.initThreeValues.bind(this);
    this.updateThreeValues          = this.updateThreeValues.bind(this);
    this.updateThreeEmptyValues     = this.updateThreeEmptyValues.bind(this);

    this.getPoints                  = this.getPoints.bind(this);
    this.IsThreeInit                = this.IsThreeInit.bind(this);
    this.IsTwoInit                  = this.IsTwoInit.bind(this);
    this.IsOneInit                  = this.IsOneInit.bind(this);

    this.findIndicator              = this.findIndicator.bind(this);
    this.AddIndicator               = this.AddIndicator.bind(this);

    this.renderUdr                  = this.renderUdr.bind(this);

    this.state = {points: this.props.oData.closes}

    // let z = Utilities.FindItem(ConnectionOrd.oSettings, this.props.oData.token);
    // let oSett      : ISettings | undefined;
    // let sSvAccount : string | undefined;

    // //alert(this.sSvAccount)
    // //Utilities.Sendlog("Saved account: " + this.sSvAccount + " " + this.props.oData.token);
  
    // if (z != AppMain.IMAGINARY)
    //   {
    //   oSett      = ConnectionOrd.oSettings[z];
    //   sSvAccount = oSett?.sAccount;
    //   }

    /*   -----------------------------------------------------------------   */

    let oCSett : IChartSettings | undefined;

    if (this.props.iSettIndex < ConnectionOrd.oSettings.length &&
      ConnectionOrd.oSettings[this.props.iSettIndex].token == this.props.oData.token)
        oCSett = ConnectionOrd.oSettings[this.props.iSettIndex].oChartSettings;
    else
      {
      let z = Utilities.FindItem(ConnectionOrd.oSettings, this.props.oData.token);

      if (z != AppMain.IMAGINARY)
        oCSett = ConnectionOrd.oSettings[z].oChartSettings;
      }

    /*   -----------------------------------------------------------------   */      
    
    if (oCSett)
      {
      if (oCSett?.bCandles == true)
        this.iChartType = ChartConfig.TYPE_CANDLE; //   = oCSett?.bCandles? true : false;
      else if (oCSett?.iChartType)
        this.iChartType = oCSett?.iChartType;

      /*   ---------------------------------------------------------------   */

      if (oCSett.iColIndex != undefined)
        this.iColIndex = oCSett.iColIndex;

      /*   ---------------------------------------------------------------   */

      if (oCSett.iLineWidth != undefined)
        {
        this.iLineWidth = oCSett.iLineWidth;
        }

      /*   ---------------------------------------------------------------   */      

      if (oCSett?.oIndicators2?.length)
        {
        for (let i = 0; i < oCSett.oIndicators2.length; i++)
          {
          this.AddIndicator(oCSett.oIndicators2[i])
          }
        }
      else if (oCSett?.oIndicators?.length)
        {
        this.AddIndicator(oCSett.oIndicators[0])
        }
    }

    /*   -----------------------------------------------------------------   */

    this.oPosData = ConnectionOrd.GetPosData(this.props.oData, this.props.oData.sv_account);

    /*   -----------------------------------------------------------------   */
    
    this.PopulateOrders();

    /*   -----------------------------------------------------------------   */

    if (this.props.oData.closes.length)
      this.UpdateDataOnLoad();
    }

    /*   -----------------------------------------------------------------   */

    AddIndicator(oIndSettings : IIndicatorSettings)
    {
    let iIndex   = ConnectionHis.FindIndicatorIndex(oIndSettings.iId);

    if (iIndex == undefined)
      return;

    /*   -----------------------------------------------------------------   */

    let oIndInfo = ConnectionHis.oIndicators[iIndex];
   
    if (!oIndInfo)
      return;

    /*   -----------------------------------------------------------------   */      

    let oInd : IIndicator = {iIndicator: oIndSettings.iId, 
                             iIndex: iIndex,
                             oL1: {iPeriod: 0}, 
                             oL2: {iPeriod: 0}, 
                             oL3: {iPeriod: 0},
                             bOverlay: oIndInfo.bOverlay};

    /*   -----------------------------------------------------------------   */

    this.oIndicators.push(oInd);

    if (oIndInfo.bOverlay)
      this.iIndexOvr = this.oIndicators.length - 1;
    else
      this.iIndexUdr = this.oIndicators.length - 1;
    
    /*   -----------------------------------------------------------------   */

    if (oIndSettings.iPeriod1 == undefined && oIndSettings.iId != undefined)
      {
      this.SetIndicatorLines(oInd, 
                             {
                              index_sel: iIndex,
                              period1: oIndInfo.iPeriod1,
                              period2: oIndInfo.iPeriod2,
                              period3: oIndInfo.iPeriod3
                             });
      }
    else
      {
      this.SetIndicatorLines(oInd,
                             {
                              index_sel: iIndex,
                              period1: oIndSettings.iPeriod1,
                              period2: oIndSettings.iPeriod2 == undefined? 0 : oIndSettings.iPeriod2,
                              period3: oIndSettings.iPeriod3 == undefined? 0 : oIndSettings.iPeriod3
                             });
      }
    }

    /*   -----------------------------------------------------------------   */

    findIndicator(iIndicator? : number,
                  bDelete     : boolean = false)
    {
    if (iIndicator == undefined)
      return(undefined);

    for (let i = 0; i < this.oIndicators.length; i++)
      {
      if (this.oIndicators[i].iIndicator == iIndicator)
        {
        if (bDelete)
          {
          this.oIndicators.splice(i, 1);
          return(undefined);
          }
        else
          return(this.oIndicators[i]);
        }
      }

    return(undefined);
    }

    /*   -----------------------------------------------------------------   */

    SetIndicatorLines(oIndIn: IIndicator, 
                      oData : IChartConfigStateToChart)
    {
    if (oData.index_sel == undefined)
      return;

    //let opInd = this.findIndicator(oData.indicator);

    if (oIndIn != undefined)
        {
        let oInd = ConnectionHis.oIndicators[oData.index_sel]; //ConnectionHis.FindIndicator(oIndIn.iIndicator);

        if (oInd != undefined)
          {
          oIndIn.oL1.sColor  = ConnectionHis.oColors[this.iColIndex][oInd.iCol1];
          oIndIn.oL2.sColor  = ConnectionHis.oColors[this.iColIndex][oInd.iCol2];
          oIndIn.oL3.sColor  = ConnectionHis.oColors[this.iColIndex][oInd.iCol3];

          // this.oL1.iPeriod = oInd.oPeriods[this.iPdIndex].iPeriod1;
          // this.oL2.iPeriod = oInd.oPeriods[this.iPdIndex].iPeriod2;

          if (oData.period1 == undefined || 
              oData.period2 == undefined)
            return;

          if (oInd.iPeriod1)
            oIndIn.oL1.iPeriod = oData.period1; //oInd.iPeriod1;
          else
            oIndIn.oL1.iPeriod = 1;

          if (oInd.iPeriod2)
            oIndIn.oL2.iPeriod = oData.period2;

          if (oInd.iPeriod3)
            oIndIn.oL3.iPeriod = oData.period3? oData.period3 : 0;
          }
        }
    }

    /*   -----------------------------------------------------------------   */

    SelectAccount(oData : PosData)
    {
    Utilities.Sendlog("***Bars Setting account called");
  
    if (this.oPosData?.acc_key != oData.acc_key)
      {
      if (this.oPosData)
        {
        // this.oOBModify?.Hide();
  
        // for (let i = 0; i < this.obOrderRef.length; i++)
        //   this.obOrderRef[i].ClearAllOrders();
        }
  
  
      this.oPosData = oData;
      this.PopulateOrders();
      this.forceUpdate();

      // this.PopulateOrders(true);
  
      Utilities.Sendlog("***Bars Setting account: " + this.oPosData?.acc_key);
      }
    }
  
    /*   -------------------------------------------------------------------   */

    SelectAccountForce(oData : PosData)
    {
    Utilities.Sendlog("***Bars Setting account called");

    if (this.oPosData?.acc_key != oData.acc_key ||
        this.oPosData?.token   != oData.token)
      {
      if (this.oPosData)
        {
        // this.oOBModify?.Hide();
  
        // for (let i = 0; i < this.obOrderRef.length; i++)
        //   this.obOrderRef[i].ClearAllOrders();
        }
  
      this.oPosData = oData;
      this.PopulateOrders();
      this.forceUpdate();

      // this.PopulateOrders(true);
  
      Utilities.Sendlog("***Bars Setting account: " + this.oPosData?.acc_key);
      }
    }
  
    /*   -------------------------------------------------------------------   */

    GetData(sAccKey : string = "")
    {
      if (Connection.oAccStore.size > 0)
        {
        let acckey = sAccKey;
        
        if (!acckey)
          acckey = Connection.oAccStore.keys().next().value;
  
        let token   = "";
  
        if (this.props.oData.trading_symbol && this.props.oData.trading_exchange)
          token = this.props.oData.trading_symbol + "." + this.props.oData.trading_exchange;
        else
          token = this.props.oData.token;
  
        let key = acckey + token;
  
        //alert(key);
         
         let data1 = Connection.oPosStore.get(key);
  
         if (data1 == undefined)
          {
          //Utilities.Sendlog("New Pos: " + acckey + " token: " + token);
  
          data1 = new PosData(acckey, token);
          Connection.oPosStore.set(key, data1);
          }
  
         //alert(key + data1?.net_qty);
  
         return(data1);
        }
      // else
      //   Utilities.Sendlog("account size is 0");
    }
  
    /*   -------------------------------------------------------------------   */

    PopulateOrders()
    {
      
    if (!this.oPosData             || 
        this.props.oData.close_times.length == 0)
      return;

    //this.bUpdateOrders = true;

    this.oOrders.clear();
    this.oCloses  = undefined;
    this.oFutData = undefined;

    //this.oOrders = new Array(this.props.oData.close_times.length);

   let time_len = this.props.oData.close_times.length;

    for (let i = 0; i < this.oPosData.orders.length; i++)
        {
        let oOrder = Connection.oOrdStore.get(this.oPosData.orders[i]);

        this.PopulateOrders2(oOrder);
        }
    }

    /*   -----------------------------------------------------------------   */

    PopulateOrders2(oOrder : OrdData | undefined)
    {
    let time_len = this.props.oData.close_times.length;

    if (oOrder?.completion_reason == "filled" && oOrder.time && oOrder.fill_price)
        {
        if (oOrder.time > this.props.oData.close_times[time_len - 1])
          {
          if (!this.oFutData)
            this.oFutData = new ChartOrd();

          if (oOrder.txn_type_api == TransactionType.BUY)  
            this.oFutData.iBuys  += oOrder.qty;
          else
            this.oFutData.iSells += oOrder.qty;

          if (!this.oCloses)
            {
            this.oCloses  = new Array(0);

            for (let a = 0; a < this.props.oData.closes.length; a++)
              this.oCloses.push(this.props.oData.closes[a]);

            this.oCloses.push(oOrder.fill_price);

            if (this.dMin > oOrder.fill_price)
              this.dMin = oOrder.fill_price;

            if (this.dMax < oOrder.fill_price)
              this.dMax = oOrder.fill_price;

            this.dMean = (this.dMin + this.dMax)/2;
  
            Utilities.Sendlog("bars " + oOrder.basket_id + ": " + oOrder.time);
            }
          else
            {
            this.oCloses.pop();
            this.oCloses.push(oOrder.fill_price);

            if (this.dMin > oOrder.fill_price)
              this.dMin = oOrder.fill_price;

            if (this.dMax < oOrder.fill_price)
              this.dMax = oOrder.fill_price;

            this.dMean = (this.dMin + this.dMax)/2;

            Utilities.Sendlog("bars " + oOrder.basket_id + ": " + oOrder.time);
            }

          return(true);
          }
          

        for (let j = 0; j < time_len; j++)  
          {
          if (j - 1 >= 0 && oOrder.time > this.props.oData.close_times[j-1] && oOrder.time <= this.props.oData.close_times[j])
            {
            Utilities.Sendlog("bars " + oOrder.basket_id + ": " + oOrder.time + ">= " + this.props.oData.close_times[j] + "< " + this.props.oData.close_times[j+1]);

            let oData = this.oOrders.get(this.props.oData.close_times[j]);

            if (oData == undefined)
              {
              oData = new ChartOrd();
              this.oOrders.set(this.props.oData.close_times[j], oData);
              }

            if (oOrder.txn_type_api == TransactionType.BUY)  
              oData.iBuys++;
            else
              oData.iSells++;

            break;
            }
          }

        return(true);  
        }

    return(false);
    }

    /*   -----------------------------------------------------------------   */

    PopulateOrders_New(oOrder : OrdData | undefined)
    {
    let time_len = this.props.oData.close_times.length;

    if (oOrder?.completion_reason == "filled" && oOrder.time && oOrder.fill_price)
        {
        if (oOrder.time > this.props.oData.close_times[time_len - 1])
          {
          if (!this.oFutData)
            this.oFutData = new ChartOrd();

          if (oOrder.txn_type_api == TransactionType.BUY)  
            this.oFutData.iBuys  += oOrder.qty;
          else
            this.oFutData.iSells += oOrder.qty;

          if (!this.oCloses)
            {
            this.oCloses  = new Array(0);

            for (let a = 0; a < this.props.oData.closes.length; a++)
              this.oCloses.push(this.props.oData.closes[a]);

            this.oCloses.push(oOrder.fill_price);

            Utilities.Sendlog("bars " + oOrder.basket_id + ": " + oOrder.time);
            }
          else
            {
            this.oCloses.pop();
            this.oCloses.push(oOrder.fill_price);

            Utilities.Sendlog("bars " + oOrder.basket_id + ": " + oOrder.time);
            }

          return(true);
          }
          

        for (let j = 0; j < time_len; j++)  
          {
          if (j - 1 >= 0 && oOrder.time > this.props.oData.close_times[j-1] && oOrder.time <= this.props.oData.close_times[j])
            {
            Utilities.Sendlog("bars " + oOrder.basket_id + ": " + oOrder.time + ">= " + this.props.oData.close_times[j] + "< " + this.props.oData.close_times[j+1]);

            let oData = this.oOrders.get(this.props.oData.close_times[j]);

            if (oData == undefined)
              {
              oData = new ChartOrd();
              this.oOrders.set(this.props.oData.close_times[j], oData);
              }

            if (oOrder.txn_type_api == TransactionType.BUY)  
              oData.iBuys++;
            else
              oData.iSells++;

            break;
            }
          }

        return(true);  
        }

    return(false);
    }

    /*   -----------------------------------------------------------------   */

    getDotColor(dataPoint: any, iIndex: number)
    {
      let oData;

      if (iIndex == undefined)
        return('transparent');

      if (iIndex < this.props.oData.close_times.length)
        {
        oData = this.oOrders.get(this.props.oData.close_times[iIndex]);
        }
      else if (this.oFutData)
        {
        oData = this.oFutData;
        }
  
      if (oData != undefined)
          {
          if (oData.iBuys > 0 && oData.iSells > 0) 
            return('#9f00ff');
          else if (oData.iBuys > 0 )
            return('dodgerblue');
          else if (oData.iSells > 0 )
            return('hotpink');
          } 
  
      return('transparent')                                        
    }

    /*   -----------------------------------------------------------------   */

    getFont()
    {
    if (FontInfo.iFont <= 0)
      return('Arial');

    let sSysFont = FontInfo.Fonts[FontInfo.iFont].normal

    if (sSysFont)
      {
      let sFont = processFontFamily(sSysFont);

      if (sFont)
        return(sFont);
      }

    return('Arial')
    }

    /*   -----------------------------------------------------------------   */

    componentDidMount() 
    {
      ConnectionOrd.BindEvent(this.onOrderEvent, true);
      this.props.bindEvent(this.UpdateData, true);

      this.props.qbRef?.oChartConfig?.ApplySettings(this.OnConfirmApply, true);
    }

    /*   -----------------------------------------------------------------   */

    componentWillUnmount() 
    {
      ConnectionOrd.BindEvent(this.onOrderEvent, false);
      this.props.bindEvent(this.UpdateData, false);

      this.props.qbRef?.oChartConfig?.ApplySettings(this.OnConfirmApply, false);

    }

    /*   -----------------------------------------------------------------   */

    /*   -----------------------------------------------------------------   */

    OnConfirmApply(iMsg   : number,
                   oData  : IChartConfigStateToChart)
    {
    switch(iMsg)
      {
      default:
        return;
      case ChartConfig.MSG_CHANGE_COL:
        if (oData.col_index == undefined)
          return;

        this.iColIndex = oData.col_index;

        for (let i = 0; i < this.oIndicators.length; i++)
          {
            let oIndInfo = ConnectionHis.oIndicators[this.oIndicators[i].iIndex];

            this.oIndicators[i].oL1.sColor  = ConnectionHis.oColors[this.iColIndex][oIndInfo.iCol1];
            this.oIndicators[i].oL2.sColor  = ConnectionHis.oColors[this.iColIndex][oIndInfo.iCol2];
            this.oIndicators[i].oL3.sColor  = ConnectionHis.oColors[this.iColIndex][oIndInfo.iCol3];
          }
        break;
      case ChartConfig.MSG_CHANGE_WIDTH:
        if (oData.line_width == undefined)
          return;

        this.iLineWidth = oData.line_width;
        break;
      case ChartConfig.MSG_CHANGE_PERIOD:
        if (oData.index_sel == undefined)
          return;

        let oInd = this.findIndicator(ConnectionHis.oIndicators[oData.index_sel].iId);

        if (oInd)
          {
          this.SetIndicatorLines(oInd, oData);
          this.setIndicatorValues(oInd, true);
          }

        break;
      case ChartConfig.MSG_CHANGE_TYPE:
          if (oData.chart_type != undefined)
            {
            this.iChartType = oData.chart_type;
            //this.forceUpdate();
            
            }
          break;
      case ChartConfig.MSG_CHANGE_INDICATOR:
        if (oInd?.bOverlay)
          this.findMinMaxFromStore();

        if (oData.index_prev != undefined)
            {
            //delete
            this.findIndicator(ConnectionHis.oIndicators[oData.index_prev].iId, true);

            this.iIndexOvr = undefined;
            this.iIndexUdr = undefined;

            for (let i = 0; i < this.oIndicators.length; i++)
              {
              if (this.oIndicators[i].bOverlay)
                this.iIndexOvr = i;
              else
                this.iIndexUdr = i;
              }
            }

        /*   -------------------------------------------------------------   */

        if (oData.index_sel != undefined)
          {
          let oInd : IIndicator = {iIndicator: ConnectionHis.oIndicators[oData.index_sel].iId,
                                   iIndex: oData.index_sel,
                                   oL1: {iPeriod: 0}, 
                                   oL2: {iPeriod: 0}, 
                                   oL3: {iPeriod: 0},
                                  
                                   bOverlay: oData.overlay};

          /*   -----------------------------------------------------------   */

          this.oIndicators.push(oInd);

          if (oData.overlay)
            this.iIndexOvr = this.oIndicators.length - 1;
          else
            this.iIndexUdr = this.oIndicators.length - 1;

          /*   -----------------------------------------------------------   */

          this.SetIndicatorLines(oInd, oData);
          this.setIndicatorValues(oInd, true);
          }

        break;
        }

    this.forceUpdate();      
    }

  /*   -------------------------------------------------------------------   */

    onOrderEvent (sToken?    : string,
                  oOrdData?  : OrdData,
                  oPosData?  : PosData,
                  dRemPrice? : number,
                  sBasketId? : string)

    {
    if (oOrdData && oPosData)
      {
      if (oPosData.token   == this.oPosData?.token && 
          oPosData.acc_key == this.oPosData?.acc_key)
          {
          if (this.PopulateOrders2(oOrdData))
            {
            this.forceUpdate();
            }
          }
      }
    }

    /*   -----------------------------------------------------------------   */

    // render_old() 
    // {
    //  return (
    //    <View style={{flexDirection:'column', backgroundColor:'transparent'}}>
    //    <LineChart
    //    data=
    //    {
    //      {
    //        labels: ["9:30", "", "", "", "", "", "12:30", "", "", "", "", "", "03:30"],
    //        datasets: [
    //          {
    //            data: this.oCloses? this.oCloses : this.props.oData? this.props.oData.closes : [0],
    //            color: (opacity = 1) => 'slategrey', //'#ECEFF1', // optional
    //            strokeWidth: 2, // optional
    //            //withDots:this.oOrders.size || this.oFutData? true : false
    //          },

    //          // {
    //          //   data: [100,200],//this.oCloses? this.oCloses : this.props.oData? this.props.oData.closes : [0],
    //          //   color: (opacity = 1) => 'transparent', //'#ECEFF1', // optional
    //          //   strokeWidth: 1, // optional
    //          //   withDots:true //this.oOrders.size || this.oFutData? true : false
    //          // },              


    //        ],
    //        //legend: ["Sales Chart"] // optional
    //      }
    //    }
       
    //    width={(Utilities.WIDTH - 45) < 200? 200 : Utilities.WIDTH - 45}
    //    height={100}
    //    withVerticalLines={false}
    //    withHorizontalLines={false}
    //    bezier={true}
    //    //withHorizontalLabels={false}
    //    withVerticalLabels={false}
       
    //    withDots={this.oOrders.size || this.oFutData? true : false}
    //    fromZero={false}
    //    yAxisInterval={2}
    //    yLabelsOffset={4}

    //    getDotColor={(dataPoint: any, iIndex: number)=>{return(this.getDotColor(dataPoint, iIndex))}}

    //    chartConfig={{

    //      propsForLabels: {fontSize:FontInfo.iFontSize-2, fontFamily: this.getFont()},//FontInfo.iFont > 0 ? this.sFont : "Arial"},
         
    //      backgroundColor: FontInfo.sBackground, //'#1cc910',
    //      backgroundGradientFrom: FontInfo.sBackground, //'#183086',
    //      backgroundGradientTo: FontInfo.sBackground,
    //      decimalPlaces: this.props.oData?.display_fmt? 3 : (this.props.oData?.f2qp > 6? 6 : this.props.oData?.f2qp), // optional, defaults to 2dp
    //      color: (opacity = 255) => 'slategrey', //'#ECEFF1',
    //    }}

    //    yAxisLabel={''}
    //    // xAxisLabel={'test'}
    //    // xLabelsOffset={20}
       
       
    //    style={{opacity: (this.props.oData?.closes.length == 0 || (this.props.oData?.closes.length == 1 && this.props.oData?.closes[0] == 0) )? 0 : 1, /*borderColor:'red', borderWidth:1, */marginRight: 0, borderRadius: 7, /*alignSelf:'center', justifyContent:'flex-start'*/}}
    //    />


    //   <View style={{flexDirection:'row', width:'100%'}}>
    //   <Text style={[FontInfo.appStyles.txt_normal, {flex:1, color:'slategrey', fontSize:FontInfo.iFontSize - 2, marginLeft:62, marginTop:0}]}>{this.props.oData.times.length? this.props.oData.times[0] : " "}</Text> 
      
    //   {/* <TouchableOpacity style={{flexDirection:'row', alignItems:'center', alignContent:'center'}} */}
    //   <TouchableOpacity style={{marginRight:32, marginTop:-5, borderRadius:9, borderWidth:1, width:18, height:18, borderColor:'rgba(112,128,144,.2)', alignItems:'center', alignContent:'center'}} 
    //   onPress={()=>{this.props.qbRef?.oChartConfig?.ShowChartInfo()}}>
    //   {/* <Text style={[FontInfo.appStyles.txt_normal, {color:'slategrey', fontSize:FontInfo.iFontSize - 2, marginTop:0, }]}>{this.props.oData.times.length? this.props.oData.times[this.props.oData.times.length - 1] : " "}</Text>  */}
    //   {/* <Feather name="info" size={FontInfo.iFontSize + 4} color='slategray' style={{marginRight:32, marginTop:0}} /> */}
    //   <Text style={[FontInfo.appStyles.txt_normal, {marginTop:2, alignSelf:'center', fontSize:FontInfo.iFontSize-2, color:'slategrey'}]}>i</Text>
    //   </TouchableOpacity>

    //   {/* <TouchableOpacity style={{position:'absolute', backgroundColor:'transparent', right:30, top:-3, flexDirection:'row', alignItems:'center', justifyContent:'center'}}  
    //     onPress={()=>{this.props.qbRef?.oOrderRef?.ShowChartInfo()}}>
    //      <Text style={[FontInfo.appStyles.txt_normal, {color:'slategrey', fontSize:FontInfo.iFontSize - 2, marginTop:0}]}>{this.props.oData.times.length? this.props.oData.times[this.props.oData.times.length - 1] : " "}</Text> 
    //      <Feather name="info" size={FontInfo.iFontSize} color='slategray' />
    //   </TouchableOpacity> */}

    //   {/* <Text style={[FontInfo.appStyles.txt_normal, {color:'slategrey', position:'absolute', right:32, bottom:0, fontSize:FontInfo.iFontSize - 2, marginTop:0}]}>{this.props.oData.times.length? this.props.oData.times[this.props.oData.times.length - 1] : " "}</Text>  */}

    //   {/* <TouchableOpacity style={{position:'absolute', right:32, bottom:0, width:18, height:18, borderRadius:9, borderWidth:1, flexDirection:'row', borderColor:'rgba(112,128,144,.2)', alignItems:'center', justifyContent:'center'}}   */}
    //      {/* <Text style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize-2, color:'slategrey'}]}>i</Text> */}


    //   </View>

    //   </View>
    //  );
    // }

    renderUdr()
    {
      if (this.iIndexUdr == undefined)
        return(null);
      else
        return(
            <View style={{backgroundColor:'transparent', position:'absolute', left:0, top:1,
                          opacity: this.bChart? 1 : 0, /*borderColor:'red', borderWidth:1, */marginRight: 0, borderRadius: 7, /*alignSelf:'center', justifyContent:'flex-start'*/}} >
      
              
              <victory.VictoryChart
                  
                  minDomain={{y: this.oPoints? this.dMin2 - this.props.oData.qpc/100 : undefined}}
                  //maxDomain={100}
                  width={350}  
                  height={96} 
                  
                  padding={{ top: 2, bottom: 5, left: CHART_LEFT, right: CHART_RIGHT }} //right:35
                  theme={victory.VictoryTheme.material} 
      
                  domainPadding={{ y: [0, 10] }} //more space on top
      
                  containerComponent={
                    <victory.VictoryContainer
                      style={{
                        //pointerEvents: "auto",
                        //userSelect: "auto",
                        touchAction: "auto"
                      }}
                    />
                  }            
                  >
      
              <victory.VictoryAxis dependentAxis
                orientation={'right'} 
      
                style={{
                  
                  axisLabel: {stroke:FontInfo.sGrayTp, fontSize: FontInfo.iFontSize-2, padding: 2},
      
                  axis: {stroke: "transparent"},
                  grid: {stroke: "transparent"},
                  ticks: {stroke: "transparent", size: 5, },
      
      
                  tickLabels: {stroke:FontInfo.bDarkMode?'slategray':'slategray', fill:FontInfo.bDarkMode?'slategray':'slategray', fontFamily: this.getFont(), fontSize: FontInfo.iFontSize-2, padding: 4}
                }}
      
                tickValues = {[this.dMin2, (this.dMax2 + this.dMean2)/2, this.dMean2, (this.dMean2 + this.dMin2)/2, this.dMax2]}
                tickCount = {5}
                tickFormat = {(dPrice : number) =>  (this.dMax2 - this.dMin2) > 10? dPrice.toFixed( 0 ) : dPrice.toFixed( this.dDecimals )} //dPrice + "-" + ConnectionMkt.getFmt(dPrice, this.props.oData) }//t.toFixed(this.props.oData.qpc)}
                />
      
                {/* ** Indicators ** */}
                {
                this.iIndexUdr != undefined && this.oIndicators[this.iIndexUdr].oL1.oData?
                  <victory.VictoryLine 
                  interpolation="monotoneX"
                  style={{data: { stroke: this.oIndicators[this.iIndexUdr].oL1.sColor, strokeWidth: this.iLineWidth, }, }}

                  //labels={({ datum }) => datum._x==undefined? "" : datum._x}

                  data = { this.oIndicators[this.iIndexUdr].oL1.oData }  />
                : null
                }
                {
                this.iIndexUdr != undefined && this.oIndicators[this.iIndexUdr].oL2.oData?
                  <victory.VictoryLine 
                  interpolation="monotoneX"
                  style={{data: { stroke: this.oIndicators[this.iIndexUdr].oL2.sColor, strokeWidth: this.iLineWidth, }, }}
                  data = { this.oIndicators[this.iIndexUdr].oL2.oData }  />
                : null
                }
                {
                this.iIndexUdr != undefined && this.oIndicators[this.iIndexUdr].oL3.oData?
                  <victory.VictoryLine 
                  interpolation="monotoneX"
                  style={{data: { stroke: this.oIndicators[this.iIndexUdr].oL3.sColor, strokeWidth: this.iLineWidth, }, }}
                  data = { this.oIndicators[this.iIndexUdr].oL3.oData }  />
                : null
                }
      
              </victory.VictoryChart>
            </View>
            );
        
    }

    render() 
    {
     return (
      <View style={{flexDirection:'column', backgroundColor:'transparent'}}>

      <View style={{width:350, height:96, backgroundColor:'transparent'}}></View>

      {/* BASIC CHART /> */}
      <View style={{backgroundColor:'transparent', position:'absolute', left:0, top:1,
                    opacity: this.bChart? 1 : 0, /*borderColor:'red', borderWidth:1, */marginRight: 0, borderRadius: 7, /*alignSelf:'center', justifyContent:'flex-start'*/}} >

        
        <victory.VictoryChart
            
            minDomain={{y: this.oPoints? this.dMin - this.props.oData.qpc/100 : undefined}}
            //maxDomain={100}
            width={350}  
            height={96} 
            
            padding={{ top: 2, bottom: 5, left: CHART_LEFT, right: CHART_RIGHT }} //right:35
            theme={victory.VictoryTheme.material} 

            domainPadding={{ y: [0, 10] }}

            containerComponent={
              <victory.VictoryContainer
                style={{
                  //pointerEvents: "auto",
                  //userSelect: "auto",
                  touchAction: "auto"
                }}
              />
            }            
            >

        <victory.VictoryAxis dependentAxis 
          style={{
            
            axisLabel: {stroke:'slategray', fontSize: FontInfo.iFontSize-2, padding: 2},

            axis: {stroke: "transparent"},
            grid: {stroke: "transparent"},
            ticks: {stroke: "transparent", size: 5, },

            tickLabels: {stroke:'slategray', fill:'slategray', fontFamily: this.getFont(), fontSize: FontInfo.iFontSize-2, padding: 4}
          }}

          tickValues = {[this.dMin, (this.dMax + this.dMean)/2, this.dMean, (this.dMean + this.dMin)/2, this.dMax]}
          tickCount = {5}
          tickFormat = {(dPrice : number) =>  dPrice.toFixed( this.dDecimals )} //dPrice + "-" + ConnectionMkt.getFmt(dPrice, this.props.oData) }//t.toFixed(this.props.oData.qpc)}
          />
        {/* ** Line ** */}
        {
        //!this.bCandles? 
        this.iChartType == ChartConfig.TYPE_LINE?

        <victory.VictoryArea
            interpolation="monotoneX"

            //minDomain={{x:0, y:80}}
            //maxDomain={{x:0, y:90}}
            //maxDomain={90}

            style={{

              data: { stroke: "slategray", strokeWidth: 2, fill: FontInfo.bDarkMode? '#333537' : '#f0f2f4', }, 

              // parent: { border: "1px solid red"},
              labels: {fontSize:FontInfo.iFontSize-2}
            }}

            data = { this.oCloses? this.oCloses : this.props.oData? this.props.oData.closes : [0] }//{this.oCloses? this.oCloses : this.props.oData? this.props.oData.closes : [0] }

           //y0={2}
          containerComponent={<victory.VictoryContainer responsive={false}/>}
          />

         : null
         }


          {/* ** Candles ** */}
          {
          //this.bCandles? 
          this.iChartType == ChartConfig.TYPE_CANDLE?

          <victory.VictoryCandlestick
          
            //candleWidth={60}
            //wickStrokeWidth={10}
            
            candleColors={{ positive: FontInfo.sGreen, negative: "red" }}

            // closeLabels
            closeLabels={({ datum }) => (datum.open == datum.close /*&& datum.high == datum.low*/)? "-" : ""}//datum._x}

            wickStrokeWidth={1}

            style={{
              closeLabels: { fill: FontInfo.sGreen },

              data: {
                //fill: ({ datum }) => { return datum.open <= datum.close? FontInfo.sGreen : 'red' }, 
                stroke: ({ datum }) => { return FontInfo.sGreen }, //datum.open <= datum.close? FontInfo.sGreen : 'red' }, 
                strokeWidth: 0
              },
            }}

            data={this.props.oData.ohlc}

            closeLabelComponent={
              <victory.VictoryLabel
                textAnchor="middle"
                dx={0}
                dy={-1}
                //dx={({ text }) => text.length && text[0].length === 1 ? -4 : -8}
              />
            }
            /> 
            
          : null
          }

          {/* ** Indicators ** */}

          {/* {
          this.oIndicators?.map((oInd: IIndicator)=>{return(
          <>
          {
          oInd.oL1.oData?
            <victory.VictoryLine 
            interpolation="monotoneX"
            style={{data: { stroke: oInd.oL1.sColor, strokeWidth: 1, }, }}
            data = { oInd.oL1.oData }  />
          : null
          }

          {
          oInd.oL2.oData?
            <victory.VictoryLine 
            interpolation="monotoneX"
            style={{data: { stroke: oInd.oL2.sColor, strokeWidth: 1, }, }}
            data = { oInd.oL2.oData }  />
          : null
          }

          {
          oInd.oL3.oData?
            <victory.VictoryLine 
            interpolation="monotoneX"
            style={{data: { stroke: oInd.oL3.sColor, strokeWidth: 1, }, }}
            data = { oInd.oL3.oData }  />
          : null
          }
          </>
          )//return
          })
          } */}

          {
          this.iIndexOvr != undefined && this.oIndicators[this.iIndexOvr].oL1.oData?
            <victory.VictoryLine 
            interpolation="monotoneX"
            style={{data: { stroke: this.oIndicators[this.iIndexOvr].oL1.sColor, strokeWidth: this.iLineWidth, }, }}
            data = { this.oIndicators[this.iIndexOvr].oL1.oData }  />
          : null
          }
          {
          this.iIndexOvr != undefined && this.oIndicators[this.iIndexOvr].oL2.oData?
            <victory.VictoryLine 
            interpolation="monotoneX"
            style={{data: { stroke: this.oIndicators[this.iIndexOvr].oL2.sColor, strokeWidth: this.iLineWidth, }, }}
            data = { this.oIndicators[this.iIndexOvr].oL2.oData }  />
          : null
          }
          {
          this.iIndexOvr != undefined && this.oIndicators[this.iIndexOvr].oL3.oData?
            <victory.VictoryLine 
            interpolation="monotoneX"
            style={{data: { stroke: this.oIndicators[this.iIndexOvr].oL3.sColor, strokeWidth: this.iLineWidth, }, }}
            data = { this.oIndicators[this.iIndexOvr].oL3.oData }  />
          : null
          }

          

          {/* ** Dots ** */}
          {
          (this.oOrders.size || this.oFutData)? 

              <victory.VictoryScatter 
                style={{
                  data: { fill: ({ datum }) => {return(this.getDotColor(datum, datum._x))}, 
                        }, 
                  }}
  
                //labels={({ datum }) => datum._x==undefined? "" : datum._x}
                size={5} 
                data={this.oCloses? this.oCloses : this.props.oData? this.props.oData.closes : [0]} 
                /> 

          : null
          }

        </victory.VictoryChart>
      </View>


      <this.renderUdr/>


      <View style={{flexDirection:'row', backgroundColor:'transparent', marginTop:2, marginLeft:-2,  width:'100%', alignItems:'center', }}>
       <Text style={[FontInfo.appStyles.txt_normal, {flex:1, color:'slategrey', fontSize:FontInfo.iFontSize - 2, marginLeft:59, marginTop:0}]}>{this.props.oData.times.length? this.props.oData.times[0] : " "}</Text> 
       <TouchableOpacity style={{marginRight:31, marginTop:-2, borderRadius:9, borderWidth:1, height:20, ///width:40, 
                                borderColor:'transparent', alignItems:'center', flexDirection:'row'}} 
       onPress={()=>{this.props.qbRef?.oChartConfig?.ShowChartInfo()   }}> 
       <Text style={[FontInfo.appStyles.txt_normal, {marginTop:2, marginRight:2, opacity:.8, fontSize:FontInfo.iFontSize, color:'slategrey'}]}>{this.oIndicators.length? ConnectionHis.oIndicators[this.oIndicators[0].iIndex].sId : ""}</Text>
        <Ionicons style={{marginTop:2}} name="ios-settings-sharp" size={16} color="rgba(112,128,144,.4)" />
       {/* <Text style={[FontInfo.appStyles.txt_normal, {marginTop:2, alignSelf:'center', fontSize:FontInfo.iFontSize-2, color:'slategrey'}]}>i</Text> */}
       </TouchableOpacity>

       </View>
      </View>
     );
  }

}